import React from 'react'
import "./Furnitures.css"
import one from "./sofa 1 copy.jpg"
import two from "./sofa 10.jpeg"
import three from "./sofa 2.jpg"
import four from "./sofa 3.jpeg"
import five from "./sofa 4.jpeg"
import six from "./sofa 9.jpg"
import seven from "./sofa 8.jpg"
import eight from "./sofa 7.jpeg"
import nine from "./sofa 6.jpg"
import ten from "./sofa 5.jpg"





const Furnitures = () => {
  return (
    <div>
      <div className='hello'>
     <div  className='paintin'>
     <img src={one} alt='knacker 104'/>
      <img src={six} alt='knacker 104'/>
      <img src={three} alt='knacker 104'/>
     </div>
      <div className='paintin'>
      <img src={four} alt='knacker 104'/>
      <img src={nine} alt='knacker 104'/>
      <img src={seven} alt='knacker 104'/>
      </div>
      <div className='paintin'>
      <img src={ten} alt='knacker 104'/>
      <img src={eight} alt='knacker 104'/>
      <img src={five} alt='knacker 104'/>
      </div>
      <div className='paintin'>
        <img src={two} alt='jwdb'/>
      </div>      
    </div>
    </div>
  )
}

export default Furnitures
